export default function NoResultsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="205"
      height="253"
      viewBox="0 0 205 253"
      fill="none"
    >
      <path
        d="M201.609 48.1063C199.326 42.0075 195.971 36.4721 192.012 31.3246C184.362 21.377 174.912 11.8063 163.476 6.33678C151.135 0.446531 137.302 -0.0510299 123.92 1.35751C98.7598 4.00995 72.9232 11.0234 52.5781 26.6307C33.6671 41.1221 19.8195 63.8051 20.1342 88.1161C20.1959 91.7025 20.4597 95.2825 20.9244 98.8392C21.1695 100.482 22.9805 102.161 24.4512 102.256C39.3671 103.237 61.6951 101.594 66.1768 101.594C70.6586 101.594 72.2354 98.2282 73.461 93.3551C75.2537 86.2282 78.3817 79.6429 82.8268 74.1258L81.4549 74.2209C80.489 74.2795 76.4939 75.0734 76.0768 74.3343C75.5025 73.3136 79.5195 69.2124 80.1012 68.5246C82.2964 65.9636 84.5207 63.516 86.9464 61.1673C89.4525 58.7417 91.8195 56.3234 94.2122 53.8904C97.5049 50.5282 101.123 47.3453 104.613 44.1295C104.939 43.8295 105.279 43.5295 105.631 43.2258C103.515 42.8004 101.569 41.7696 100.029 40.2587C99.9043 40.1264 99.8203 39.9607 99.7874 39.7817C99.7544 39.6027 99.7739 39.418 99.8435 39.2499C99.913 39.0817 100.03 38.9372 100.18 38.8338C100.329 38.7305 100.506 38.6726 100.688 38.6673C107.321 38.349 112.326 33.1063 118.531 31.3502C123.601 29.916 132.173 31.288 133.549 37.2953L133.593 37.438C137.785 38.0599 139.86 41.6746 141.543 45.0734C143.134 48.2929 143.705 51.8417 143.954 55.4051C146.862 55.0758 149.771 55.5148 151.739 57.6002C155.229 61.288 152.581 66.7758 148.787 69.1429C149.856 71.0991 150.769 73.1372 151.516 75.238C153.686 81.3383 154.567 87.8225 154.102 94.2807C153.477 102.984 148.545 111.421 143.463 119.583C143.537 121.555 143.591 123.505 143.617 125.408C143.617 126.256 143.617 127.105 143.635 127.95C146.09 129.732 151.121 134.012 153.334 135.845C160.172 141.498 165.737 147.918 172.018 154.058C173.815 150.548 175.823 147.152 178.033 143.887C185.42 132.816 193.867 122.488 198.228 109.727C200.515 103.039 201.707 96.0624 202.618 89.0746C203.504 82.2002 204.287 75.2343 204.506 68.3051C204.707 61.4636 204.023 54.549 201.609 48.1063Z"
        fill="#F4F6F9"
      />
      <path
        d="M139.293 81.9293C139.329 78.0037 139.351 74.3488 139.337 71.422C141.833 71.2125 144.304 70.7604 146.712 70.072C151.469 68.7622 155.859 61.9354 151.739 57.6C148.468 54.1464 142.626 55.2073 138.459 56.8171C138.217 54.933 137.925 53.0708 137.555 51.2671C136.501 46.0903 134.837 39.9256 129.872 37.1342C121.458 32.411 111.012 38.25 104.628 44.1293C101.123 47.3415 97.5124 50.5281 94.2197 53.8903C91.827 56.3232 89.4636 58.7415 86.9539 61.1671C84.5283 63.5159 82.3112 65.9744 80.1087 68.5244C79.527 69.1976 75.51 73.3134 76.0844 74.3342C76.5014 75.0659 80.4966 74.2793 81.4624 74.2208C83.4746 74.0964 85.4612 73.9281 87.4587 73.8073C89.0063 73.7122 93.2722 73.8073 93.2722 73.8073C93.2722 73.8073 93.0526 77.3269 93.06 79.1927C93.1002 90.4244 93.8941 101.66 93.8941 112.961"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M142.984 63.8632C143.679 63.7279 144.4 63.5925 145.055 63.4462"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.564 62.5499V59.5389"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M108.422 62.5499V59.5389"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M110.712 75.1978C112.176 74.1002 115.889 72.0295 117.342 73.9539"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.496 127.851C145.896 129.567 151.077 133.979 153.334 135.845C160.435 141.699 166.164 148.409 172.746 154.771C180.469 162.231 187.183 171.326 193.428 180.062"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.1758 123.527C90.7697 126.271 93.8794 128.129 97.0404 128.129"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.653 152.342C143.653 152.342 143.584 146.049 143.606 142.574C143.639 136.859 143.69 131.111 143.606 125.411C143.449 113.737 142.3 100.446 141.063 88.9321C140.829 86.7809 139.325 76.3651 133.702 78.4212C130.874 79.4565 131.507 86.4443 131.507 88.9321C131.507 92.8321 131.507 98.1333 131.507 101.7C131.507 105.267 131.064 109.211 131.064 109.211"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M131.727 109.902C131.727 109.902 128.603 107.671 126.685 106.946C123.495 105.746 121.022 104.495 117.707 104.019C115.732 103.734 112.911 103.58 110.983 104.407C109.585 105.007 107.357 107.59 107.559 108.797"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M122.69 115.244C122.69 115.244 118.666 112.683 116.489 111.776C114.21 110.814 110.855 108.966 108.396 109.233C104.372 109.665 99.473 114.919 99.2754 119.075"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M115.223 121.87C115.223 121.87 111.931 119.492 109.845 118.943C107.877 118.431 105.821 117.787 103.754 117.915C100.827 118.094 98.7745 119.693 97.7318 122.499C96.5866 125.579 96.133 138.417 102.378 136.983C105.437 136.281 104.248 130.522 103.494 128.503C104.994 130.888 107.862 132.161 110.606 131.173C103.326 131.243 108.045 149.506 115.637 148.584"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.46826 200.799C1.72436 195.922 2.94997 192.714 5.06827 188.36C7.13168 184.123 13.117 176.96 16.6036 173.964C20.0902 170.967 25.6146 168.11 31.6036 167.012C35.628 161.21 46.4427 151.324 53.9207 146.129C61.3988 140.934 70.5671 134.422 84.2097 126.139C85.3695 125.437 88.1866 123.509 88.1866 123.509C88.1866 123.509 89.4927 119.85 90.3817 118.153C91.3036 116.389 91.9768 114.911 93.3085 112.976C96.3597 113.261 101.46 113.759 101.46 113.759"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M114.392 149.415C113.979 153.64 114.202 161.221 114.202 161.221"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M127.721 161.228C123.107 162.164 117.089 162.794 112.816 161.228C112.816 165.538 113.182 171.772 113.405 176.316C113.613 180.764 113.185 188.755 114.137 189.629C115.088 190.503 118.362 190.573 120.762 190.423C126.854 190.032 132.923 187.54 138.188 184.88C139.893 184.024 141.378 183.336 142.981 182.356C143.774 181.869 145.542 180.479 146.101 179.714C146.892 178.65 146.709 175.489 146.709 174.066C146.709 171.099 146.343 163.064 146.01 160.141C145.476 155.539 145.465 151.463 143.968 151.463C142.263 155.74 133.165 160.127 127.721 161.228Z"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M108.385 143.828C107.603 146.667 93.8611 166.438 100.212 167.444C101.207 167.601 103.106 165.82 104.054 166.416C105.795 167.514 102.996 172.09 102.528 173.038C101.361 175.412 97.4245 182.104 102.605 179.312C103.618 181.387 100.618 187.537 98.8074 189.136"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.934 181.325C58.2633 183.033 57.612 185.715 56.4706 186.941C54.6413 188.913 51.5864 189.575 46.9584 189.63C54.0998 190.127 52.234 194.572 49.3218 197.803C46.4096 201.033 39.3413 200.953 39.3413 199.347C39.3413 196.087 45.8681 194.382 49.1572 194.258C51.5755 194.166 59.0352 192.794 56.9315 198.831C61.5962 194.441 64.8852 192.791 70.2816 191.21C75.6779 189.63 79.1572 192.063 79.7938 197.097C82.2413 193.855 84.312 192.022 88.0108 190.186C90.8828 188.763 94.673 188.675 97.7059 189.136C101.807 189.758 106.45 191.265 110.247 192.769"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M114.14 189.629C112.359 190.61 110.705 192.216 109.337 193.756C107.774 195.509 106.838 198.801 105.678 200.96C103.223 205.562 101.288 211.625 101.123 216.86C101.024 220.032 102.429 222.048 103.611 224.879C104.661 227.404 104.324 227.177 102.989 229.12C101.013 231.999 100.75 236.031 100.084 239.345C99.5756 241.881 99.1549 244.383 99.7183 246.959C100.033 248.422 100.9 249.746 100.717 251.301C100.688 250.906 100.856 250.694 100.929 250.31"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.105 179.715C149.204 186.637 149.566 196.979 150.283 204.937C150.901 211.756 151.6 218.663 151.889 225.508C151.977 227.543 150.814 235.679 152.306 236.85"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.463 191.733C154.274 190.69 158.449 190.855 163.476 190.855C168.345 190.855 171.89 192.216 175.721 195.373C179.463 198.439 181.735 203.331 182.555 207.951C183.067 210.856 184.483 218.513 181.929 220.467C179.376 222.421 177.828 219.651 176.409 215.817"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M153.894 213.439C155.167 215.019 155.842 216.997 155.8 219.026C155.69 221.075 153.89 225.977 155.259 227.675C159.232 232.643 163.073 221.045 163.084 218.093C163.095 215.14 163.128 212.847 162.565 211.266"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M160.593 226.072C160.937 227.664 161.357 229.8 163.574 229.837C165.554 229.87 166.966 227.012 167.562 225.523C169.34 221.078 169.344 217.207 168.868 212.4C168.623 209.927 167.668 207.457 167.014 205.357"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.983 200.798C176.57 207.885 178.666 220.145 173.273 228.724C171.81 231.04 166.867 232.306 167.562 225.523"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.756 230.422C96.6341 232.551 91.3109 235.306 85.9109 236.641C82.6782 237.405 79.3854 237.888 76.0694 238.083C72.9816 238.299 68.9572 239.437 65.917 238.504"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.934 184.215V184.837"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M139.322 78.3623C139.433 78.4896 139.575 78.5855 139.735 78.6404C139.894 78.6952 140.066 78.7072 140.231 78.6749C140.397 78.6427 140.551 78.5674 140.679 78.4566C140.806 78.3459 140.902 78.2036 140.957 78.044C141.868 75.7463 142.554 73.3656 143.006 70.9354C141.796 71.1606 140.574 71.3231 139.347 71.422C139.347 73.4379 139.34 75.8049 139.322 78.3623Z"
        fill="#333333"
      />
      <path
        d="M140.031 60.7208C140.138 59.1806 140.375 57.6586 140.5 56.1257C141.628 55.7834 142.783 55.5386 143.953 55.394C143.705 51.8306 143.134 48.2818 141.542 45.0623C139.86 41.6635 137.785 38.0489 133.592 37.4269L133.549 37.2843C132.173 31.2769 123.601 29.905 118.53 31.3391C112.311 33.0916 107.32 38.3343 100.688 38.6562C100.506 38.6616 100.329 38.7194 100.179 38.8228C100.03 38.9261 99.9128 39.0706 99.8432 39.2388C99.7736 39.407 99.7541 39.5917 99.7871 39.7707C99.8201 39.9497 99.9041 40.1153 100.029 40.2477C104.031 44.1513 109.124 43.7379 113.964 43.3318C117.118 43.0684 121.11 41.0818 124.153 40.1599C126.766 39.3696 128.716 40.0428 130.702 41.9891C129.605 45.5306 129.667 48.4025 131.247 51.966C132.828 55.5294 136.274 57.8599 138.297 61.1782C138.403 61.3496 138.56 61.4826 138.747 61.5575C138.934 61.6323 139.14 61.645 139.334 61.5937C139.529 61.5424 139.702 61.4298 139.827 61.2726C139.953 61.1154 140.024 60.9219 140.031 60.7208Z"
        fill="#333333"
      />
      <path
        d="M155.16 215.843C154.391 217.277 153.224 217.573 151.775 217.855"
        stroke="#333333"
        strokeWidth="2.56098"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
